import { provisionBookingsPlatform as publicProvisionBookingsPlatform } from './bookings-provisioner-v1-apps-cloned-bookings-provisioner.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const provisionBookingsPlatform: MaybeContext<
  BuildRESTFunction<typeof publicProvisionBookingsPlatform> &
    typeof publicProvisionBookingsPlatform
> = /*#__PURE__*/ createRESTModule(publicProvisionBookingsPlatform);

export {
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  BasedOn,
  Strategy,
  WebhookIdentityType,
} from './bookings-provisioner-v1-apps-cloned-bookings-provisioner.universal.js';
export {
  AppsClonedFromTemplate,
  App,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
  CreateBusinessScheduleRequest,
  CreateBusinessScheduleResponse,
  ProvisionBookingsPlatformRequest,
  TimeSlotsConfiguration,
  DisplayTimeZone,
  StaffSelection,
  SplitInterval,
  ExtendedFields,
  ProvisionBookingsPlatformResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  ProvisionBookingsPlatformOptions,
} from './bookings-provisioner-v1-apps-cloned-bookings-provisioner.universal.js';
export {
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  BasedOnWithLiterals,
  StrategyWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './bookings-provisioner-v1-apps-cloned-bookings-provisioner.universal.js';
